import React from 'react';
import './ResultModal.css';

interface ResultModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  variant?: 'success' | 'error' | 'warning';
  children: React.ReactNode;
}

const ResultModal: React.FC<ResultModalProps> = ({
  isOpen,
  onClose,
  title,
  variant = 'success',
  children
}) => {
  if (!isOpen) return null;

  return (
    <div className="result-modal-overlay" onClick={onClose}>
      <div className="result-modal" onClick={(e) => e.stopPropagation()}>
        <div className={`result-modal-header ${variant}`}>
          <h3>{title}</h3>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>
        <div className="result-modal-body">
          {children}
        </div>
        <div className="result-modal-footer">
          <button className={`modal-btn ${variant}`} onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResultModal;
